import React from "react";
import { useTranslation } from "react-i18next";
import LinkIcon from "../../../../assets/profile/icons/link.svg";
import CopyIcon from "../../../../assets/profile/icons/copy.svg";
import { AffiliatesSharingOptions } from "../elements/AffiliatesSharingOptions";
import { useAppDispatch } from "../../../../store/store";
import {
  setAffiliatesLinkSidebarClose,
  setLinkCopiedOpen,
} from "../../../../store/features/profileSlice";
import { QRCodeContainer } from "../elements/QRCodeContainer";
import { truncateStringWithEllipsis } from "../../../../helpers/formatter";
import { useMediaQuery } from "@mui/material";
import { useLanguageTheme } from "../../../../hooks/useLanguageTheme";
import BlueCross from "../../../../assets/profile/icons/blueCross.svg";
import { useUserProfile } from "../../../../hooks/useUserProfile";

export const AffiliatesLinkManagementSection = () => {
  const { t } = useTranslation(["profile"]);
  const dispatch = useAppDispatch();
  const maxWidth1090px = useMediaQuery("(max-width: 1090px)");
  const maxWidth720px = useMediaQuery("(max-width: 720px)");

  const langTheme = useLanguageTheme();
  const [userLink, setUserLink] = React.useState("");
  const { profile }: { profile: any; isLoading: boolean } = useUserProfile();

  React.useEffect(() => {
    if (profile) {
      setUserLink(profile.affiliateLink);
    }
  }, [profile]);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(userLink);
      dispatch(setLinkCopiedOpen());
    } catch (err) {
      console.error("error:", err);
    }
  };

  React.useEffect(() => {
    if (!maxWidth720px) {
      dispatch(setAffiliatesLinkSidebarClose());
    }
  }, [maxWidth720px]);

  return (
    <div
      className="affiliate-link-management-wrapper"
      style={{
        fontFamily: langTheme.mainFont(),
      }}
    >
      <div className="affiliate-link-management-container">
        <div className="affiliate-link-management-title-container">
          <div className="affiliate-link-management-title">
            {t("affiliate_link_management")}
          </div>
          {maxWidth720px && (
            <img
              style={{
                cursor: "pointer",
              }}
              src={BlueCross}
              onClick={() => dispatch(setAffiliatesLinkSidebarClose())}
            />
          )}
        </div>
        <div
          className="affiliate-link-management-link-container"
          onClick={handleCopy}
        >
          <div className="affiliate-link-management-link-name">
            <img src={LinkIcon} />
            <div>
              {truncateStringWithEllipsis(userLink, maxWidth1090px ? 25 : 33)}
            </div>
          </div>
          <img src={CopyIcon} />
        </div>
      </div>

      <AffiliatesSharingOptions linkValue={userLink} />
      <QRCodeContainer linkValue={userLink} />

      {maxWidth720px && (
        <div
          className="affiliate-link-management-got-it-btn"
          onClick={() => dispatch(setAffiliatesLinkSidebarClose())}
        >
          {t("got_it")}
        </div>
      )}
    </div>
  );
};
